import React, { useState, useRef, useEffect } from "react";
import useClickOutside from "../../../hook/UseClickOutSide";
import { BackPackSVG } from "../../images-svg/BaseMapsSvg";
import { Tooltip } from "@mantine/core";
import BaseMapsOptions from "./BaseMapsOptions";
import LayerInfoOption from "./LayerInfoOption";

interface BaseMapPropType {
  onMeasure?: () => void;
}

function BaseMaps({ onMeasure }: BaseMapPropType) {
  const [isOpenOption, setIsOpenOption] = useState(false);
  const [isOpenLayerInfo, setIsOpenLayerInfo] = useState(false);
  const [isOpenBaseMap, setIsOpenBaseMap] = useState(false);
  const baseMapRef = useRef(null);
  const tooltipStyles = {
    tooltip: {
      backgroundColor: "white",
      color: "#323232",
      fontSize: "12px",
    },
  };
  const tooltipOptionStyles = {
    tooltip: {
      backgroundColor: "white",
      color: "#323232",
      fontSize: "12px",
      marginTop: "12px",
    },
  };

  const handleOpenOption = (value: boolean) => {
    setIsOpenOption(value);
  };
  const handleOpenBaseMap = (value: boolean) => {
    setIsOpenBaseMap(value);
  };
  const handleOpenLayerInfo = (value: boolean) => {
    setIsOpenLayerInfo(value);
  };
  useClickOutside(baseMapRef, () => {
    setIsOpenOption(false);
    setIsOpenBaseMap(false);
    setIsOpenLayerInfo(false);
  });

  return (
    <div className="relative" ref={baseMapRef}>
      <Tooltip
        label="เครื่องมือ"
        position="left"
        styles={tooltipStyles}
        disabled={isOpenOption}
      >
        <div
          className="bg-primary-contrast duration-300 w-8 h-8 p-[6px] rounded-[10px] border-[1px] border-gray-1  flex gap-2 cursor-pointer"
          onClick={() => handleOpenOption(!isOpenOption)}
        >
          <BackPackSVG />
        </div>
      </Tooltip>

      {isOpenOption && (
        <>
          <div className="absolute top-0 w-auto max-w-[112px] -left-[120px] h-11 px-2 flex gap-2 items-center bg-primary-contrast rounded-xl shadow-z4">
            <Tooltip
              label="แผนที่ฐาน"
              position="bottom"
              styles={tooltipOptionStyles}
              disabled={isOpenBaseMap}
            >
              <button type="button" onClick={() => handleOpenBaseMap(true)}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.8842 2.63589L15.0175 2.68089L16.0192 3.01422C16.405 3.14339 16.7442 3.25589 17.0117 3.38089C17.3017 3.51589 17.5675 3.68922 17.7708 3.97172C17.9742 4.25339 18.055 4.56089 18.0917 4.87839C18.125 5.17256 18.125 5.52922 18.125 5.93672V12.7801C18.125 13.3617 18.125 13.8526 18.08 14.2409C18.0333 14.6442 17.9283 15.0426 17.6342 15.3642C17.46 15.5549 17.2484 15.7075 17.0125 15.8126C16.6142 15.9892 16.2033 15.9626 15.8058 15.8801C15.4225 15.8001 14.9575 15.6451 14.4058 15.4609L14.37 15.4492C13.4367 15.1376 13.1158 15.0409 12.8058 15.0517C12.682 15.0559 12.5589 15.0724 12.4383 15.1009C12.1358 15.1717 11.8525 15.3501 11.0333 15.8959L9.88167 16.6642L9.765 16.7417C8.88 17.3326 8.265 17.7426 7.545 17.8392C6.82583 17.9359 6.12417 17.7017 5.11583 17.3642L4.9825 17.3201L3.98083 16.9867C3.595 16.8576 3.25583 16.7451 2.98833 16.6201C2.69833 16.4851 2.4325 16.3117 2.22917 16.0284C2.02583 15.7467 1.945 15.4401 1.90833 15.1217C1.875 14.8276 1.875 14.4717 1.875 14.0642V7.22089C1.875 6.63839 1.875 6.14756 1.92 5.76006C1.96667 5.35672 2.07167 4.95839 2.36583 4.63672C2.53997 4.44607 2.75162 4.29343 2.9875 4.18839C3.38583 4.01089 3.7975 4.03756 4.19417 4.12089C4.5775 4.20006 5.0425 4.35589 5.59417 4.54006L5.63 4.55172C6.56333 4.86256 6.88417 4.96006 7.195 4.94922C7.31854 4.94496 7.44136 4.92849 7.56167 4.90006C7.86417 4.82839 8.1475 4.65006 8.96667 4.10506L10.1183 3.33672L10.235 3.25839C11.12 2.66839 11.735 2.25839 12.4542 2.16172C13.1742 2.06506 13.8758 2.29839 14.8842 2.63589ZM13.125 3.42172V13.8167C13.5717 13.8651 14.0417 14.0217 14.6608 14.2284L14.765 14.2634C15.3625 14.4626 15.7583 14.5934 16.0608 14.6567C16.3575 14.7184 16.4583 14.6901 16.5042 14.6701C16.5829 14.6352 16.6535 14.5844 16.7117 14.5209C16.745 14.4842 16.8033 14.3967 16.8383 14.0959C16.8742 13.7892 16.875 13.3717 16.875 12.7426V5.96922C16.875 5.51922 16.8742 5.23589 16.85 5.02089C16.8267 4.82172 16.79 4.74756 16.7567 4.70256C16.7242 4.65756 16.6658 4.59839 16.485 4.51422C16.2883 4.42256 16.0183 4.33256 15.5933 4.19006L14.6225 3.86672C13.8833 3.62006 13.445 3.48006 13.125 3.42172ZM11.875 13.9667V3.69506C11.6158 3.84506 11.2833 4.06256 10.8117 4.37672L9.66 5.14506L9.56833 5.20589C8.995 5.58922 8.5675 5.87422 8.125 6.03422V16.3059C8.38417 16.1559 8.71667 15.9376 9.18833 15.6234L10.34 14.8559L10.4317 14.7951C11.005 14.4117 11.4325 14.1267 11.875 13.9667ZM6.875 16.5792V6.18339C6.42833 6.13506 5.95833 5.97839 5.33917 5.77172L5.235 5.73672C4.6375 5.53756 4.24167 5.40672 3.93833 5.34339C3.6425 5.28172 3.54167 5.30922 3.49667 5.32922C3.41759 5.36427 3.34665 5.41535 3.28833 5.47922C3.255 5.51506 3.19667 5.60256 3.16167 5.90339C3.12583 6.21006 3.125 6.62839 3.125 7.25756V14.0309C3.125 14.4809 3.12583 14.7642 3.15 14.9792C3.17333 15.1784 3.21 15.2517 3.24333 15.2976C3.27583 15.3426 3.33417 15.4017 3.515 15.4859C3.71167 15.5776 3.98167 15.6676 4.40667 15.8101L5.3775 16.1334C6.11667 16.3792 6.55417 16.5192 6.875 16.5784V16.5792Z"
                    fill="#8E8E8E"
                  />
                </svg>
              </button>
            </Tooltip>

            <div className="w-[1px] h-full bg-gray-1" />
            <Tooltip
              label="ชั้นข้อมูล"
              position="bottom"
              styles={tooltipOptionStyles}
            >
              <button onClick={() => handleOpenLayerInfo(true)}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.2657 10.0218L18.0368 10.9416L18.4076 11.1415C19.1975 11.5676 19.1975 12.666 18.4076 13.092L13.377 15.8053C12.2104 16.4345 10.7896 16.4345 9.62295 15.8053L4.59244 13.092C3.80252 12.666 3.80252 11.5676 4.59244 11.1415L4.96321 10.9416L6.63612 10.0218M16.6509 14.1169L18.2608 14.8948C19.091 15.296 19.1177 16.4318 18.3071 16.869L13.377 19.5281C12.2104 20.1573 10.7896 20.1573 9.62295 19.5281L4.76483 16.9078C3.94033 16.4631 3.98576 15.3022 4.84266 14.919L6.63612 14.1169M13.377 11.8489L18.4076 9.13569C19.1975 8.70964 19.1975 7.61124 18.4076 7.18519L13.377 4.47194C12.2104 3.84269 10.7896 3.84269 9.62295 4.47194L4.59244 7.18519C3.80252 7.61124 3.80252 8.70964 4.59244 9.13569L9.62295 11.8489C10.7896 12.4782 12.2104 12.4782 13.377 11.8489Z"
                    stroke="#8E8E8E"
                  />
                </svg>
              </button>
            </Tooltip>

            <div className="w-[1px] h-full bg-gray-1" />
            <Tooltip
              label="วัดระยะทาง"
              position="bottom"
              styles={tooltipOptionStyles}
            >
              <button className="relative" onClick={onMeasure}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.408 3.45163L12.2113 4.25496C12.3251 4.37289 12.388 4.5308 12.3865 4.69467C12.385 4.85854 12.3192 5.01527 12.2033 5.1311C12.0873 5.24692 11.9306 5.31258 11.7667 5.31392C11.6028 5.31527 11.445 5.2522 11.3271 5.13829L10.5238 4.33496L9.64047 5.21829L11.0321 6.61163C11.1425 6.73011 11.2026 6.88681 11.1998 7.04873C11.1969 7.21065 11.1313 7.36513 11.0168 7.47964C10.9023 7.59416 10.7478 7.65975 10.5859 7.66261C10.424 7.66546 10.2673 7.60536 10.1488 7.49496L8.7563 6.10329L7.87214 6.98663L8.67547 7.78996C8.73519 7.84759 8.78284 7.91653 8.81563 7.99277C8.84842 8.069 8.8657 8.15101 8.86646 8.23399C8.86722 8.31698 8.85144 8.39929 8.82005 8.47611C8.78866 8.55294 8.74229 8.62274 8.68363 8.68145C8.62498 8.74016 8.55522 8.7866 8.47842 8.81806C8.40163 8.84952 8.31934 8.86538 8.23635 8.8647C8.15336 8.86401 8.07134 8.84681 7.99507 8.81409C7.91881 8.78137 7.84982 8.73379 7.79214 8.67413L6.98797 7.87079L6.10464 8.75413L7.4963 10.1475C7.55771 10.2047 7.60696 10.2737 7.64112 10.3503C7.67528 10.427 7.69365 10.5098 7.69513 10.5937C7.69661 10.6776 7.68117 10.761 7.64974 10.8388C7.6183 10.9166 7.57152 10.9873 7.51217 11.0467C7.45282 11.106 7.38212 11.1528 7.3043 11.1842C7.22648 11.2157 7.14312 11.2311 7.0592 11.2296C6.97528 11.2281 6.89252 11.2098 6.81585 11.1756C6.73919 11.1415 6.67019 11.0922 6.61297 11.0308L5.22047 9.63913L4.33714 10.5225L5.13964 11.3258C5.20104 11.383 5.25029 11.452 5.28445 11.5287C5.31861 11.6053 5.33698 11.6881 5.33846 11.772C5.33994 11.8559 5.32451 11.9393 5.29307 12.0171C5.26164 12.0949 5.21485 12.1656 5.1555 12.225C5.09615 12.2843 5.02546 12.3311 4.94763 12.3626C4.86981 12.394 4.78645 12.4094 4.70253 12.408C4.61861 12.4065 4.53585 12.3881 4.45919 12.3539C4.38252 12.3198 4.31352 12.2705 4.2563 12.2091L3.45297 11.4066C3.0663 11.7975 2.78714 12.0908 2.5913 12.3483C2.34964 12.665 2.29297 12.8516 2.29297 13.0133C2.29297 13.1741 2.34964 13.3608 2.5913 13.6775C2.8438 14.0091 3.23297 14.4008 3.81464 14.9816L5.01964 16.1866C5.60047 16.7675 5.99214 17.1575 6.3238 17.41C6.64047 17.6516 6.82714 17.7083 6.98797 17.7083C7.14964 17.7083 7.3363 17.6516 7.65297 17.41C7.9838 17.1575 8.3763 16.7683 8.9563 16.1866L16.188 8.95496C16.7688 8.37496 17.1588 7.98246 17.4113 7.65163C17.653 7.33496 17.7096 7.14829 17.7096 6.98663C17.7096 6.82579 17.653 6.63913 17.4113 6.32246C17.1588 5.99079 16.7696 5.59913 16.188 5.01829L14.983 3.81329C14.4021 3.23246 14.0105 2.84246 13.6788 2.58996C13.3621 2.34829 13.1755 2.29163 13.0146 2.29163C12.853 2.29163 12.6663 2.34829 12.3496 2.58996C12.0921 2.78579 11.7988 3.06496 11.408 3.45163ZM11.5913 1.59579C12.0196 1.26913 12.4696 1.04163 13.0146 1.04163C13.5588 1.04163 14.0096 1.26913 14.4371 1.59579C14.843 1.90579 15.2938 2.35663 15.8363 2.89829L17.103 4.16496C17.6446 4.70663 18.0955 5.15829 18.4055 5.56413C18.7321 5.99163 18.9596 6.44246 18.9596 6.98663C18.9596 7.53163 18.7321 7.98163 18.4055 8.40996C18.0955 8.81579 17.6446 9.26663 17.103 9.80829L9.80964 17.1016C9.26797 17.6433 8.81714 18.0941 8.4113 18.4041C7.98297 18.7308 7.53297 18.9583 6.98797 18.9583C6.4438 18.9583 5.99297 18.7308 5.56547 18.4041C5.15964 18.0941 4.7088 17.6433 4.1663 17.1016L2.89964 15.835C2.35797 15.2933 1.90714 14.8416 1.59714 14.4358C1.27047 14.0083 1.04297 13.5575 1.04297 13.0133C1.04297 12.4683 1.27047 12.0183 1.59714 11.59C1.90714 11.1841 2.35797 10.7333 2.89964 10.1916L10.193 2.89829C10.7346 2.35663 11.1855 1.90579 11.5913 1.59579Z"
                    fill="#8E8E8E"
                  />
                </svg>
              </button>
            </Tooltip>

            <BaseMapsOptions
              open={isOpenBaseMap}
              onClose={() => handleOpenBaseMap(false)}
            />
            <LayerInfoOption
              open={isOpenLayerInfo}
              onClose={() => handleOpenLayerInfo(false)}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default BaseMaps;
